export const isOpenDevTool = (): boolean => {
  return (
    import.meta.env.MODE === "development" ||
    import.meta.env.MODE === "standalone"
  );
};
